import {
  APP_MANAGED_ROUTES,
  AuthSignIn,
  AuthSignOut,
} from '@highmark-web/highmark-common';
import { RouteObject } from 'react-router-dom';
import { BrandedLandingPage } from 'pages/branded-landing.page';
import { PrivacyPage } from 'pages/static/privacy/privacy.page';

const signInPaths = [
  `${APP_MANAGED_ROUTES.SIGN_IN}/*`,
  `${APP_MANAGED_ROUTES.SIGN_IN_ALTERNATIVE}/*`,
  `${APP_MANAGED_ROUTES.START_LOGIN}/*`,
];

export const PublicRoutes: RouteObject[] = [
  ...signInPaths.map((path) => ({ path, element: <AuthSignIn /> })),
  {
    path: `${APP_MANAGED_ROUTES.SIGN_OUT}/*`,
    element: <AuthSignOut />,
  },
  { path: '', element: <BrandedLandingPage /> },
  { path: `${APP_MANAGED_ROUTES.PRIVACY}/*`, element: <PrivacyPage /> },
];
